let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2gdIM")).then(() => parcelRequire('ki8JG'));